export default __webpack_public_path__ + "static/media/m-bicca-v3.41b1de6e.jpg";